import { UserService } from '@shared/services/user.service';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  HostBinding,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { NavigateService } from '@core/routes/services/navigate.service';
import { BasePanelService } from '@modules/base-panel/pages/base-panel/services/base-panel.service';
import { filter, map, mergeMap } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { foundRouteDataHelper } from '@shared/helpers/found-route-data.helper';
import { Config } from '@shared/configs/config';
import { ListEvent, ListEventType } from '@shared/services/base-list.service';
import { TacticsListService } from '@modules/tactics/modules/tactics-list/shared/services/tactics-list.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'df-base-left-side-navigation-menu',
  templateUrl: './base-left-side-navigation-menu.component.html',
  styleUrls: ['./base-left-side-navigation-menu.component.scss'],
})
export class BaseLeftSideNavigationMenuComponent implements AfterViewInit, OnInit, OnDestroy {
  readonly Config = Config;
  leftNavigationComponent;
  inited = false;
  location = location;
  sub: Subscription = new Subscription();

  @ViewChild('container', { read: ViewContainerRef })
  container!: ViewContainerRef;
  disableTacticsLinks = false;

  @HostBinding('class.short')
  get short() {
    return this.basePanelService?.routeData?.shortLeftNavigation;
  }

  constructor(
    public n: NavigateService,
    private router: Router,
    private route: ActivatedRoute,
    private resolver: ComponentFactoryResolver,
    private changes: ChangeDetectorRef,
    public basePanelService: BasePanelService,
    public userService: UserService,
    private tacticsListService: TacticsListService,
  ) {
    this.setRouterListener();
  }

  ngOnInit() {
    this.listenListEvents();
  }

  ngAfterViewInit() {
    this.inited = true;
    this.setLeftNavigationComponent();
  }

  private listenListEvents() {
    const sub = this.tacticsListService.emitter.subscribe((res: ListEvent) => {
      switch (res.type) {
        case ListEventType.START_GETTING_RECORDS:
          this.disableTacticsLinks = true;
          this.changes.detectChanges();
          break;
        case ListEventType.END_GETTING_RECORDS:
          this.disableTacticsLinks = false;
          this.changes.detectChanges();
          break;
      }
    });

    this.sub.add(sub);
  }

  setRouterListener() {
    this.foundLeftNavigationDataInRouteSnapshot();
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.route),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        mergeMap((route) => route.data),
      )
      .subscribe((routeData) => {
        this.detectHeader(routeData);
        this.changes.detectChanges();
      });
  }

  foundLeftNavigationDataInRouteSnapshot(): void {
    const data = foundRouteDataHelper('leftNavigationComponent', this.route.snapshot);

    if (data) {
      this.detectHeader(data);
    }
  }

  detectHeader(routeData) {
    const data = {};
    if (routeData.leftNavigationComponent && routeData.leftNavigationComponent !== this.leftNavigationComponent) {
      this.leftNavigationComponent = routeData.leftNavigationComponent;
      this.setLeftNavigationComponent();
    } else if (!routeData.leftNavigationComponent) {
      this.clearContainer();
    }
  }

  clearContainer() {
    this.leftNavigationComponent = null;
    this.container ? this.container.clear() : '';
  }

  setLeftNavigationComponent() {
    if (!this.inited || !this.leftNavigationComponent) return;
    this.container.clear();
    const factory = this.resolver.resolveComponentFactory(this.leftNavigationComponent);
    this.container.createComponent(factory);
    this.changes.detectChanges();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
